import React, { useState, useEffect, useContext } from "react";
import LayoutDashboard from "../../Components/Layout/LayoutDashboard";
import {
  Grid,
  Box,
  Paper,
  Container,
  Tooltip,
  Button,
  TextField,
  Typography,
  IconButton,
  InputLabel,
  FormControl,
} from "@material-ui/core";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import { makeStyles } from "@material-ui/core/styles";
import Swal from "sweetalert2";
/**Importar Select State */
import SelectState from "../Branch_Offices/SelectState";
/**Importar Select Municipalities */
import SelectMunicipalities from "../Branch_Offices/SelectMunicipality";
/**Habilitar redirecciones */
import { withRouter } from "react-router-dom";
/**Importar MethodPut */
import MethodGet from "../../Config/Services";
import SchoolContext from "../../Reducers/Schools/SchoolContext";
import { useForm } from "react-hook-form";
import Spinner from "../../Complements/Spinner";
/** Importamos los componentes de estilos del formulario lado izquierdo FORM y ado Derecho Image y descripcion* */
import GridItem from "../../Components/Grid/GridItem";
import GridContainer from "../../Components/Grid/GridContainer";
import Card from "../../Components/Card/Card";
import CardHeader from "../../Components/Card/CardHeader";
import CardAvatar from "../../Components/Card/CardAvatar";
import CardBody from "../../Components/Card/CardBody";
import SelectBranchOffice from "../SelectOptions/SelectBranchOffice";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(10),
    //marginBottom: theme.spacing(10),
  },
  typography: {
    margin: theme.spacing(1),
    //paddingLeft: theme.spacing(30),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(9),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBlockEnd: theme.spacing(1),
  },
  submit: {
    background: "indigo",
    "&:hover": {
      background: "#5902CF",
    },
    color: "white",
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  input: {
    display: "none",
  },
  containerImageProfile: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
  },
  PaperFormAdd: {
    background: "white",
    color: "black",
    boxShadow: "2px 4px 4px #cacaca",
  },
  /**
   * identificar Codigo de FORMS estilo para formularios
   */
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
}));

function AddSchool(props) {
  const classes = useStyles();

  const formSchoolContext = useContext(SchoolContext);

  const [cargando, spinnerCargando] = useState(false);
  const [school, saveSchool] = useState({});

  const { ErrorsAPI, success, UpdateSchool } = formSchoolContext;

  const { register, errors, handleSubmit } = useForm();

  const [image, setImage] = useState({
    urlPhoto: "https://pisouniversitario.com/template/images/page-404.jpg",
    image: "",
  });

  //Funciones para almacenar el id del estado
  const detectarCambiosEstado = (e) => {
    saveState({ state_id: e.target.value });
  };
  //Funciones para almacenar el id del municipio
  const detectarCambiosMunicipios = (e) => {
    saveMunicipality({ municipality_id: e.target.value });
  };

  //Extraer valores de branch(destructuracion)
  const { name, direction, number_phone } = school;

  //obtenemos el producto de session storage
  let SchoolStorageID = JSON.parse(sessionStorage.getItem("school"));

  const [officeId, saveOffice] = useState({
    id_branch_office: "",
  });

  useEffect(() => {
    let url = `/schools/${SchoolStorageID}`;

    MethodGet(url)
      .then((res) => {
        saveSchool(res.data.data);
        saveState({ state_id: res.data.data.state_id });
        saveOffice({ id_branch_office: res.data.data.shop_id });
        saveMunicipality({ municipality_id: res.data.data.municipality_id });
        if (res.data.data.image) {
          setImage({
            urlPhoto: res.data.data.image,
            image: res.data.data.image,
          });
        }
        spinnerCargando(true);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const [estadoId, saveState] = useState({
    state_id: "",
  });
  const [municipality, saveMunicipality] = useState({
    municipality_id: "",
  });

  //funcion para guardar la imagen y obtener la vista previa
  const handleChangeImage = (e) => {
    setImage({
      ...image,
      urlPhoto: URL.createObjectURL(e.target.files[0]),
      image: e.target.files[0],
    });
  };

  const detectarCambiosOffice = (e) => {
    saveOffice({ id_branch_office: e.target.value });
  };
  useEffect(() => {
    //si success retorna verdadero la pagina redireccionara al index de escuelas
    if (success) {
      //console.log("Retorna");
      props.history.push("/Escuelas");
    }
    //eslint-disable-next-line
  }, [success]);

  //funcion que agrega una escuela
  const onSubmit = (data, e) => {
    e.preventDefault();
    data.image = image.image;
    data.municipality_id = municipality.municipality_id;
    data.state_id = estadoId.state_id;
    data.id = SchoolStorageID;
    data.shop_id = officeId.id_branch_office;

    if (estadoId.state_id !== "" && municipality.municipality_id !== "") {
      //enviamos la data a la funcion que se encarga de guardar los registros editados
      UpdateSchool(data);
    } else {
      Swal.fire({
        title: "Error",
        text: "Todos los campos son Obligatorios",
        icon: "error",
      });
    }
  };

  //spinner de carga
  if (!cargando) return <Spinner />;

  return (
    <LayoutDashboard>
      <div onSubmit={handleSubmit(onSubmit)}>
        <form noValidate>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={{ marginTop: 100 }}
          >
            {/**
             * identificar Codigo de FORMS
             */}
            <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
              <Card>
                <CardHeader color="primary">
                  <h2 className={classes.cardTitleWhite}>
                    Editar la Escuela {name}
                  </h2>
                  <p className={classes.cardCategoryWhite}>
                    Completa correctamente los datos
                  </p>
                </CardHeader>
                <CardBody>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label="Nombre"
                        name="name"
                        autoComplete="name"
                        autoFocus
                        defaultValue={name}
                        error={!!errors.name}
                        inputRef={register({
                          required: {
                            value: true,
                            message: "El Nombre es requerido",
                          },
                          minLength: {
                            value: 4,
                            message: "Minimo 4 caracteres",
                          },
                          maxLength: {
                            value: 45,
                            message: "Maximo 45 caracteres",
                          },
                          pattern: {
                            value:
                              /^[A-Záéíóúñ ]+[A-Záéíóúñ ]+[A-Záéíóúñ ]+[A-Záéíóúñ ]$/i,
                            message: "Unicamente carácteres alfabéticos",
                          },
                        })}
                      />
                      <p>{errors?.name?.message}</p>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="direction"
                        label="Direccion"
                        name="direction"
                        autoComplete="direction"
                        autoFocus
                        defaultValue={direction}
                        error={!!errors.direction}
                        inputRef={register({
                          required: {
                            value: true,
                            message: "La Direccion es requerida",
                          },
                          minLength: {
                            value: 4,
                            message: "Minimo 4 caracteres",
                          },
                          maxLength: {
                            value: 255,
                            message: "Maximo 255 caracteres",
                          },
                        })}
                      />
                      <p>{errors?.direction?.message}</p>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="number_phone"
                        label="Teléfono"
                        name="number_phone"
                        autoComplete="number_phone"
                        type="number"
                        autoFocus
                        defaultValue={number_phone}
                        error={!!errors.number_phone}
                        inputRef={register({
                          required: {
                            value: true,
                            message: "El Teléfono es requerido",
                          },
                          minLength: {
                            value: 4,
                            message: "Minimo 4 caracteres",
                          },
                          maxLength: {
                            value: 10,
                            message: "Maximo 10 digitos",
                          },
                        })}
                      />
                      <p>{errors?.number_phone?.message}</p>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl
                        variant="outlined"
                        className={classes.FormControl}
                        fullWidth
                      >
                        <SelectState
                          estadoId={estadoId}
                          detectarCambiosEstado={detectarCambiosEstado}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl
                        variant="outlined"
                        className={classes.FormControl}
                        fullWidth
                      >
                        <SelectMunicipalities
                          estadoId={estadoId}
                          municipality={municipality}
                          detectarCambiosMunicipios={detectarCambiosMunicipios}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4} style={{marginTop:"-8px"}}>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        fullWidth
                      >
                        <SelectBranchOffice
                          detectarCambiosOffice={detectarCambiosOffice}
                          officeId={officeId}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Card profile>
                    <CardAvatar profile>
                      <img
                        src={image.urlPhoto}
                        alt="User"
                        width="100%"
                        height="100%"
                      />
                    </CardAvatar>
                    <CardBody profile>
                      <input
                        className={classes.input}
                        id="icon-button-file"
                        type="file"
                        name="image"
                        accept="image/png, image/jpg, image/jpeg"
                        onChange={handleChangeImage}
                      />
                      <label htmlFor="icon-button-file">
                        <IconButton
                          color="primary"
                          aria-label="upload picture"
                          component="span"
                        >
                          <Tooltip
                            title="seleccionar imagen"
                            aria-label="seleccionar imagen"
                          >
                            <PhotoCamera />
                          </Tooltip>
                        </IconButton>
                      </label>
                      <InputLabel>Selecciona Imagen de la Escuela</InputLabel>
                      <h2 className={classes.cardTitle}>Editando Escuela: </h2>
                      <h3 className={classes.cardTitle}>{name}</h3>
                      <p className={classes.description}>
                        Recuerda que la informacion que cambies o elimines de esta
                        escuela puede afectar registros previos y en un futuro.
                      </p>
                    </CardBody>
                  </Card>
                  <Grid container spacing={3} justify="center">
                    <Grid item spacing={3} xs={12} sm={12} md={6}>
                      <Button
                        type="submit"
                        fullWidth
                        variant="outlined"
                        className={classes.submit}
                      >
                        ACTUALIZAR
                      </Button>
                    </Grid>
                  </Grid>
                </CardBody>
              </Card>
            </GridItem>

          </Grid>
        </form>
      </div>
    </LayoutDashboard>
  );
}

export default withRouter(AddSchool);
